import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";

export const getTuevSystems = (state: State) => state.tuev_systems;

export const getTuevStudents = (state: State) => state.tuev_students;

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getTuevSystems,
  getTuevStudents,
};
